<template>
  <div
    class="flex align-items-center customer-list-cell"
    @click="throttledOnLinkClick"
  >
    <van-image
      round
      error-icon="user-o"
      :src="data.customerAvatar"
      fit="contain"
      class="avator"
    />
    <div class="customer-info c:col-between-start">
      <p class="customer-name">
        {{ data.customerNickname }}
        <img
          v-if="data.customerGender === 2"
          src="@/assets/icons/female.svg"
          class="gender-icon"
          alt=""
        />
        <img
          v-if="data.customerGender === 1"
          src="@/assets/icons/male.svg"
          class="gender-icon"
          alt=""
        />
      </p>
      <p class="customer-info-item">总消费金额：￥ {{ formattedPrice }}</p>
      <p class="customer-info-item">最后购买时间：{{ formattedTime }}</p>
    </div>
    <div class="arrow">
      <img
        src="@/assets/icons/arrow-right.svg"
        class="arrow-righticon"
        alt=""
      />
    </div>
  </div>
</template>
<script>
import { outputmoney, throttle } from "@/utils";
import { mapMutations } from "vuex";

export default {
  props: { data: Object },
  computed: {
    formattedPrice() {
      return outputmoney(this.data?.totalPrice || 0);
    },
    formattedTime() {
      return this.$moment(this.data?.lastOrderTime || 0).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
  },
  created() {
    this.throttledOnLinkClick = throttle(this.linkCustomerDetail, 500);
  },
  methods: {
    ...mapMutations(["setCustomerDetail"]),
    linkCustomerDetail() {
      this.setCustomerDetail(this.data);
      this.$router.push({
        path: "/customer-detail",
        query: {
          id: this.data.customerExternalUserid,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.customer-list-cell {
  gap: 8/20rem;

  box-sizing: border-box;
  width: 100%;
  height: 97/20rem;
  padding: 35/40rem 40/40rem;
  border-top: 1/20rem solid #fff;
  border-bottom: 3/20rem solid #e8e8e8;
  background: #fff;

  &:first-child {
    border-top: 1/20rem solid #e8e8e8;
  }

  .avator {
    width: 46/20rem;
    height: 46/20rem;
    border-radius: 50%;
    margin-right: 14/20rem;
  }

  .arrow {
    width: 12/20rem;
    height: 12/20rem;
    .arrow-righticon {
      width: 100%;
      height: 100%;
    }
  }

  .customer-info {
    flex: 1;

    height: 62/20rem;

    .customer-name {
      height: 20/20rem;
      line-height: 20/20rem;
      font-size: 14/20rem;
      font-weight: 500;
      color: #000;

      .gender-icon {
        width: 8/20rem;
        height: 8/20rem;
        margin-left: 6/20rem;
      }
    }

    .customer-info-item {
      height: 17/20rem;
      line-height: 17/20rem;
      font-size: 12/20rem;
      color: #7d7d7d;
    }
  }
}
</style>
